import React from "react";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {SiteMapLinkList} from "../components/SiteMapLinkList";

const links = [
    {href: rpAppLink.siteMap.article.base(), text: "Artykuły"},
    {href: rpAppLink.siteMap.vendor(), text: "Deweloperzy"},
    {href: rpAppLink.siteMap.offer.base(), text: "Inwestycje"},
    {href: rpAppLink.siteMap.house(), text: "Domy"},
    {href: rpAppLink.siteMap.flat(), text: "Mieszkania"},
    {href: rpAppLink.siteMap.commercial(), text: "Lokale użytkowe"}
];

export const SiteMapView = () => {
    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem isLinkingToCurrentLocation name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
            </Breadcrumbs>
            <article css={[mb(4)]}>
                <SiteMapHeading>Mapa strony</SiteMapHeading>
                <SiteMapBox>
                    <SiteMapLinkList links={links} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
import React from "react";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {SiteMapBox} from "../components/SiteMapBox";
import {SiteMapHeading} from "../components/SiteMapHeading";
import {SiteMapLinkList} from "../components/SiteMapLinkList";

const links = [
    {href: rpAppLink.siteMap.article.base(), text: "Artykuły"},
    {href: rpAppLink.siteMap.vendor(), text: "Deweloperzy"},
    {href: rpAppLink.siteMap.offer.base(), text: "Inwestycje"},
    {href: rpAppLink.siteMap.house(), text: "Domy"},
    {href: rpAppLink.siteMap.flat(), text: "Mieszkania"},
    {href: rpAppLink.siteMap.commercial(), text: "Lokale użytkowe"}
];

export const SiteMapView = () => {
    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                <BreadcrumbsItem isLinkingToCurrentLocation name="Mapa strony" position="2" url={rpAppLink.siteMap.base()} />
            </Breadcrumbs>
            <article css={[mb(4)]}>
                <SiteMapHeading>Mapa strony</SiteMapHeading>
                <SiteMapBox>
                    <SiteMapLinkList links={links} />
                </SiteMapBox>
            </article>
        </Container>
    );
};
